/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'tools': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M22.82 18.104a1.738 1.738 0 010 2.38l-2.38 2.381a1.738 1.738 0 01-2.381 0l-5.256-5.3c-1.034-1.034-1.213-2.561-.63-3.819L7.414 8.94H4.626L.314 3.19 3.19.314l5.75 4.313v2.83l4.762 4.762c1.258-.63 2.785-.404 3.863.629l5.256 5.255zm-7.636-7.682c-.36 0-.72.045-1.079.135l-3.728-3.684c0-1.662.584-3.37 1.887-4.627A6.404 6.404 0 0118.373.54c.404.09.584.584.27.898l-3.325 3.325.495 3.054 3.054.54 3.324-3.37c.315-.27.809-.134.899.27a6.404 6.404 0 01-1.707 6.11 6.835 6.835 0 01-1.932 1.347l-.898-.898a4.683 4.683 0 00-3.37-1.393zm-4.672 3.683c-.225.989-.09 1.932.224 2.83l-5.525 5.57a2.901 2.901 0 01-4.088 0 2.901 2.901 0 010-4.087l6.873-6.828 2.516 2.515zm-7.323 7.413c.584 0 1.079-.45 1.079-1.079 0-.584-.495-1.078-1.079-1.078-.628 0-1.078.494-1.078 1.078 0 .63.45 1.079 1.078 1.079z" _fill="#3E4749"/>'
  }
})
